import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {PartHealthLogItem} from '@backend/modules/@crt/models/parts/part-health-log-item.model';
import {TorchPartsService} from '@backend/modules/@crt/services/torch-parts.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-recent-part-health',
  templateUrl: './recent-part-health.component.html',
  styleUrls: ['./recent-part-health.component.scss']
})
export class RecentPartHealthComponent implements OnInit {

  partHealthLogItems: BehaviorSubject<PartHealthLogItem[]> = new BehaviorSubject<PartHealthLogItem[]>(null);

  @Input()
  user: string;

  @Output()
  partClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private torchPartsService: TorchPartsService, private router: Router) {
  }

  ngOnInit(): void {
    this.torchPartsService.getPartHealthLog(this.user).subscribe(items => this.partHealthLogItems.next(items));
  }

  getPartNumberType(type: 'CPN' | 'MPN') {
    if (type === 'CPN') {
      return 'Company Part Number';
    }
    return 'Manufacturer Part Number';
  }

  navigateToPartHealth(companyPartNumber: string) {
    this.partClicked.emit(true);
    return this.router.navigateByUrl(`/pages/component-reliability/component-health/details/cpn/${companyPartNumber}`)
  }
}
